"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../../styles/styles"));
const label_1 = __importDefault(require("../../label/label"));
const UserBankContent = ({ bankAccount, subheading, title }) => (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
    react_1.default.createElement(label_1.default, { subheading: subheading, title: title }),
    react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(label_1.default, { subheading: "Account Number", title: bankAccount && bankAccount.number }),
            react_1.default.createElement(label_1.default, { subheading: "Bank Name", title: bankAccount && bankAccount.bank_name })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(label_1.default, { subheading: "Account Name", title: bankAccount && bankAccount.name }),
            react_1.default.createElement(label_1.default, { subheading: "Status", title: bankAccount && bankAccount.status })))));
exports.default = UserBankContent;
